// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7008 ? "b8e21824" : chunkId) + "." + {"598":"7db70d3fae100c49","1111":"6c54cefe5adae8bf","1987":"ed32c4fceba0e55e","5896":"5ff88d9e37409caa","7008":"640fa4633089ebae"}[chunkId] + ".js";
};